:host {
  /** @prop --menu-item-background-color: Set the background color of the menu item. */
  --menu-item-background-color: var(--s-color-background-default-default);

  /** @prop --menu-item-border-color: Set the color of the menu item border. */
  --menu-item-border-color: var(--s-color-border-default);

  /** @prop --menu-item-border-size: Set the size of the menu item border. */
  --menu-item-border-size: 0px;

  /** @prop --menu-item-border-style: Set the style of the menu item border. */
  --menu-item-border-style: solid;

  /** @prop --menu-item-radius-top-left: Set the top-left border radius of the menu item. */
  --menu-item-radius-top-left: var(--s-size-radius-medium);

  /** @prop --menu-item-radius-top-right: Set the top-right border radius of the menu item. */
  --menu-item-radius-top-right: var(--s-size-radius-medium);

  /** @prop --menu-item-radius-bottom-left: Set the bottom-left border radius of the menu item. */
  --menu-item-radius-bottom-left: var(--s-size-radius-medium);

  /** @prop --menu-item-radius-bottom-right: Set the bottom-right border radius of the menu item. */
  --menu-item-radius-bottom-right: var(--s-size-radius-medium);

  /** @prop --menu-item-font-size: Set the font size of the menu item. */
  --menu-item-font-size: var(--p-size-dynamic-250);

  /** @prop --menu-item-text-color: Set the text color of the menu item. */
  --menu-item-text-color: var(--s-color-text-default);

  /** @prop --menu-item-line-height: Set the line height of the menu item. */
  --menu-item-line-height: var(--p-size-dynamic-400);

  /** @prop --menu-item-width: Set the width of the menu item. */
  --menu-item-width: unset;

  /** @prop --menu-item-gap: Set the gap property of the menu item. */
  --menu-item-gap: var(--p-size-static-150);

  /** @prop --menu-item-border: Set the shorthand for the menu item border. */
  --menu-item-border: var(--menu-item-border-size) var(--menu-item-border-style) var(--menu-item-border-color);

  /** @prop --menu-item-padding: Set the padding of the menu item. */
  --menu-item-padding: calc(var(--p-size-static-300) - var(--menu-item-border-size)) calc(var(--p-size-static-200) - var(--menu-item-border-size));

  /** @prop --background-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --background-color: var(--menu-item-background-color);

  /** @prop --border-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-color: var(--menu-item-border-color);

  /** @prop --border-size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-size: var(--menu-item-border-size);

  /** @prop --border-style: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-style: var(--menu-item-border-style);

  /** @prop --radius-top-left: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --radius-top-left: var(--menu-item-radius-top-left);

  /** @prop --radius-top-right: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --radius-top-right: var(--menu-item-radius-top-right);

  /** @prop --radius-bottom-left: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --radius-bottom-left: var(--menu-item-radius-bottom-left);

  /** @prop --radius-bottom-right: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --radius-bottom-right: var(--menu-item-radius-bottom-right);

  /** @prop --font-size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --font-size: var(--menu-item-font-size);

  /** @prop --text-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --text-color: var(--menu-item-text-color);

  /** @prop --width: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --width: var(--menu-item-width);

  /** @prop --gap: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --gap: var(--menu-item-gap);

  /** @prop --border: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border: var(--menu-item-border);

  /** @prop --padding: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding: var(--menu-item-padding);

  display: inline-block;

  width: var(--menu-item-width);
}

.anchor-c-menu-item {
  display: inline-flex;
  justify-content: flex-start;
  gap: var(--menu-item-gap);
  box-sizing: border-box;
  padding: var(--menu-item-padding);
  width: var(--menu-item-width);
  border-top-left-radius: var(--menu-item-radius-top-left);
  border-top-right-radius: var(--menu-item-radius-top-right);
  border-bottom-left-radius: var(--menu-item-radius-bottom-left);
  border-bottom-right-radius: var(--menu-item-radius-bottom-right);
  font-size: var(--menu-item-font-size);
  text-decoration: none;
  line-height: var(--menu-item-line-height);
  color: var(--menu-item-text-color);
  background-color: var(--menu-item-background-color);
  &:hover {
    --menu-item-background-color: var(--s-color-background-tertiary);
    --menu-item-border-color: var(--s-color-outline-default);
  }
  &:focus {
    outline: var(--s-size-outline-focus-ring-width) solid var(--s-color-outline-default);
    outline-offset: var(--s-size-outline-focus-ring-offset);
  }
  &:active {
    --menu-item-background-color: var(--b-color-primary-darker);
    --menu-item-border-color: var(--b-color-primary-dark);
    --menu-item-text-color: var(--s-color-text-on-dark-default);
    --menu-item-action-icon-color: var(--s-color-icon-default);
    outline: none;
    anchor-icon {
      --icon-color: var(--s-color-text-on-dark-default);
    }
  }

  &.box {
    --menu-item-border-size: var(--p-size-static-0125);
    border: var(--menu-item-border);
    border-width: var(--menu-item-border-size);
    border-color: var(--menu-item-border-color);
    --menu-item-padding: calc(var(--p-size-static-300) - var(--menu-item-border-size)) calc(var(--p-size-static-200) - var(--menu-item-border-size));
  }
  &.compact {
    --menu-item-font-size: var(--s-size-text-default);
    line-height: var(--p-size-dynamic-300);
    --menu-item-padding: calc(var(--p-size-static-150) - var(--menu-item-border-size)) calc(var(--p-size-static-200) - var(--menu-item-border-size));
  }
  anchor-icon {
    margin-left: auto;
    --icon-color: var(--s-color-icon-variant);
  }
}
